<template>
  <div id="app">
    <keep-alive :include="keepAliveViews">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keepAliveViews: [],
    };
  },
  created() {
    console.log(window.location.href);
  },
};
</script>

<style lang="less">
html,
body {
  height: 100%;
  background: #fff;
}
#app {
  height: 100%;
  font-family: 'Tahoma', 'Microsoft Yahei', 'PingFangSC-Regular', 'PingFangSC',
    arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;
  font-size: 12px;
  font-weight: 400;
}
</style>
